import React from 'react'
import axios from 'axios'
import '../../css/page/WalletIapRechargePage.css'
import {WalletIapBalance, WalletIapRechargeOption} from '../../components/wallet'
import {Page} from '../../components'

class WalletIapRechargePage extends React.Component {
    constructor() {
        super();
        this.state = {
            balance: 0,
            rechargeList: []
        }
    }

    componentDidMount() {
        document.title = '我的账户'
        this.reBalance()
    }

    reBalance() {
        axios.get('/api/wallet/iap/balance')
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        balance: res.data.data.balance,
                        rechargeList: res.data.data.lychee_info
                    })
                } else {
                    alert(res.data.msg)
                }
            })
    }

    render() {
        return (
            <Page>
                <div className='wallet-iap-recharge-page'>
                    <div className='recharge-page'>
                        <WalletIapBalance balance={this.state.balance}/>
                        <WalletIapRechargeOption rechargeList={this.state.rechargeList}
                                                 reBalance={() => this.reBalance()}/>
                    </div>
                </div>
            </Page>
        )
    }
}

export default WalletIapRechargePage



// WEBPACK FOOTER //
// ./src/pages/AppPage/WalletIapRechargePage.js